/**
 * @description 深度克隆
 * @param {*} data
 * @returns
 */
export function deepClone(data) {
  function typeOf(obj) {
    const toString = Object.prototype.toString;
    const map = {
      "[object Boolean]": "boolean",
      "[object Number]": "number",
      "[object String]": "string",
      "[object Function]": "function",
      "[object Array]": "array",
      "[object Date]": "date",
      "[object RegExp]": "regExp",
      "[object Undefined]": "undefined",
      "[object Null]": "null",
      "[object Object]": "object"
    };
    return map[toString.call(obj)];
  }
  // 获取传入拷贝函数的数据类型
  const type = typeOf(data);
  // 定义一个返回any类型的数据
  let reData;
  // 递归遍历一个array类型数据，
  if (type === "array") {
    reData = [];
    for (let i = 0; i < data.length; i++) {
      reData.push(deepClone(data[i]));
    }
  } else if (type === "object") {
    //递归遍历一个object类型数据
    reData = {};
    for (const i in data) {
      reData[i] = deepClone(data[i]);
    }
  } else {
    // 返回基本数据类型
    return data;
  }
  // 将any类型的数据return出去，作为deepClone的结果
  return reData;
}

/**
 * @desc 递归函数，根据条件过滤树形结构数据
 */

export function filterTreeData(tree, condition) {
  return tree.filter(node => {
    if (condition(node)) {
      if (node.children) {
        node.children = filterTreeData(node.children, condition);
      }
      return true;
    } else if (node.children) {
      node.children = filterTreeData(node.children, condition);
      return node.children.length > 0;
    }
    return false;
  });
}

/**
 * @desc 递归函数，根据条件查询是否满足条件(有一个成立即可)
 */

export function someTreeData(tree, condition) {
  return tree.some(node => {
    if (condition(node)) {
      if (node.children) {
        node.children = filterTreeData(node.children, condition);
      }
      return true;
    } else if (node.children) {
      node.children = filterTreeData(node.children, condition);
      return node.children.length > 0;
    }
    return false;
  });
}

/**
 * @desc 随机id
 */
export function randomId() {
  // 创建一个6字节的ArrayBuffer
  var buffer = new ArrayBuffer(6);
  // 创建一个Uint8Array视图
  var view = new Uint8Array(buffer);
  // 使用crypto.getRandomValues()填充视图
  window.crypto.getRandomValues(view);
  // 将字节转换为6位字符串
  var randomId = Array.from(view, byte => byte.toString(36)).join("");
  return randomId;
}

/**
 * @desc 时间格式化
 */
export function formatDate(date) {
  const convertTimestampToMilliseconds = timestamp => {
    // 首先检查时间戳是否为数字
    if (typeof timestamp !== "number") {
      throw new Error("Invalid timestamp, expected a number");
    }

    // 如果时间戳小于1000000000000（即1970年后的10秒），假设它是秒级的
    if (timestamp < 1000000000000) {
      // 将秒级时间戳转换为毫秒级
      return timestamp * 1000;
    } else {
      // 如果时间戳大于或等于1000000000000，假设它已经是毫秒级的
      // 直接返回，无需转换
      return timestamp;
    }
  };
  // eslint-disable-next-line @typescript-eslint/no-redeclare
  var date = new Date(convertTimestampToMilliseconds(Number(date)));
  var YY = date.getFullYear() + "-";
  var MM =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hh =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var mm =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
    ":";
  var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  return YY + MM + DD + " " + hh + mm + ss;
}

/**
 * @desc 数组去重
 */
export function arrayFilter({ data, key }) {
  let hash = {};
  const newArr = data.reduce((preVal, curVal) => {
    hash[curVal[key]] ? "" : (hash[curVal[key]] = true && preVal.push(curVal));
    return preVal;
  }, []);
  return newArr;
}

/**
 * @desc 根据时间判断是上午，下午，晚上
 */
export function getTimeState() {
  // 获取当前时间
  let timeNow = new Date();
  // 获取当前小时
  let hours = timeNow.getHours();
  // 设置默认文字
  let state = ``;
  // 判断当前时间段
  if (hours >= 0 && hours <= 10) {
    state = `早上好!`;
  } else if (hours > 10 && hours <= 14) {
    state = `中午好!`;
  } else if (hours > 14 && hours <= 18) {
    state = `下午好!`;
  } else if (hours > 18 && hours <= 24) {
    state = `晚上好!`;
  }
  return state;
}

export const getUrl = url => {
  if (!url) return;
  console.info(url);
  if (url.includes("http") || url.includes("https")) {
    return url;
  } else {
    return import.meta.env.VITE_BASE_SERVICE_URL + url;
  }
};
export const filterUrl = url => {
  if (typeof url !== "string") {
    return "";
  }
  return url.replaceAll(import.meta.env.VITE_BASE_SERVICE_URL, "");
};
export const importFile = async ({ api, key = "file", accept = "*" }) => {
  return new Promise((resolve, reject) => {
    console.info("Creating file input element...");
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.style.display = "none";

    document.body.appendChild(input);

    input.addEventListener("change", async (e) => {
      console.info("File input changed, processing file...");
      const file = e.target.files[0];
      if (!file) {
        console.info("No file selected.");
        document.body.removeChild(input);
        return reject(new Error("No file selected"));
      }

      console.info("File selected:", file.name);
      console.info("key", key);
      console.info("file", file);

      try {
        console.info("Sending file to API...");
        // 这里直接将 file 对象作为参数传递给 API
        const res = await api(file);
        console.info("API response received:", res);
        resolve(res);
      } catch (error) {
        console.info("Error during API call:", error);
        reject(error);
      } finally {
        document.body.removeChild(input);
        console.info("File input element removed from DOM.");
      }
    });

    console.info("Triggering file selection dialog...");
    input.click();
  });
};
